// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.VisualizationApi.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import vizEngineFactories from 'share/factories/Izenda.VizEngineFactories';
import HighchartVizNames from 'share/components/charting/highcharts/Izenda.HighchartVizNames';
import HighchartVizEngine from 'share/components/charting/highcharts/Izenda.HighchartVizEngine';
import HighmapVizEngine from 'share/components/charting/highcharts/Izenda.HighmapVizEngine';
import HighchartOptionsBuilder from 'share/components/charting/highcharts/Izenda.HighchartOptionsBuilder';
import HighmapOptionsBuilder from 'share/components/charting/highcharts/Izenda.HighmapOptionsBuilder';

export default {
  /**
   * Get the built-in visualization name constants
   */
  get VISUALIZATION_NAMES() {
    return HighchartVizNames;
  },

  /**
   * Register a visualization engine with a name
   * @param {string} name The name of visualization engine
   * @param {Function} vizEngineClazz The class or constructor function of visualization engine.
   * This class must inherit from VizEngine class.
   * @example
   * class D3 extends VizEngine {
   *    draw(chartContainer, chartType, options, onCompleted) {
   *      //Implement the drawing logic into chartContainer here.
   *    }
   * }
   *
   * registerVisualizationEngine('D3', D3);
   */
  registerVisualizationEngine(name, vizEngineClazz) {
    vizEngineFactories.registerVisualizationEngine(name, vizEngineClazz);
  }
};



// WEBPACK FOOTER //
// ./ui/api/Izenda.VisualizationApi.js